module.exports = __webpack_public_path__ + "img/img5987.81453f70.jpg";